import nodes from "../json/nodes.json";
import Node from "./Node";
import NodeParagrapher from "./NodeParagrapher";
import NodeCatgory from "./NodeCategory";
import NodeRealisation from "./NodeRealisation";
import NodeContact from "./NodeContact";
import ParagrapheBuilder from "./ParagrapheBuilder";
import FormBuilder from "./FormBuilder";

class NodeBuilder {

    get(nid) {
        if (nodes[nid] !== undefined) {
            let nodeData = nodes[nid];
            let node = {};

            switch (nodeData.type) {
                case 'paragrapher': {
                    let paragrapheBuilder = new ParagrapheBuilder(); // Déclaré parce qu'utilisé dans un for
                    node = new NodeParagrapher(nodeData.id, nodeData.title);
                    node = this.checkUnrequiredParams(node, nodeData);
                    node.paragraphes = nodeData.paragraphes.map(paragraphe => paragrapheBuilder.get(paragraphe));
                    return node;
                }

                case 'category': {
                    node = new NodeCatgory(nodeData.id, nodeData.title, nodeData.menuTitle);
                    node = this.checkUnrequiredParams(node, nodeData);
                    if (nodeData.image) {
                        node.image = nodeData.image
                    }
                    if (node.id !== "4") {
                        let metaDescr = `${node.title}, graphiste en Vendée (85) à proximité de Fontenay-le-Comte`;
                        node.meta = {
                            "title": `${node.title} Graphiste dans le Sud Vendée`,
                            "metaTags": [
                                {
                                    "name": "description",
                                    "content": metaDescr
                                },
                                {
                                    "name": "og:description",
                                    "content": metaDescr
                                },
                                {
                                    "name": "keywords",
                                    "content": node.menuTitle
                                }
                            ]
                        };
                    }
                    return node;
                }

                case 'realisation': {
                    node = new NodeRealisation(nodeData.id, nodeData.title, nodeData.category, nodeData.image);
                    node = this.checkUnrequiredParams(node, nodeData);
                    let metaDescr = this.clearMetaDescr(node.body);
                    node.meta = {
                        "title": `${node.title} Graphiste dans le Sud Vendée`,
                        "metaTags": [
                            {
                                "name": "description",
                                "content": metaDescr
                            },
                            {
                                "name": "og:description",
                                "content": metaDescr
                            },
                            {
                                "name": "keywords",
                                "content": nodes[node.category].menuTitle
                            }
                        ]
                    }
                    return node;
                }

                case 'contact': {
                    let formBuilder = new FormBuilder(); // Déclaré parce qu'utilisé dans un for
                    node = new NodeContact(nodeData.id, nodeData.title);
                    node = this.checkUnrequiredParams(node, nodeData);
                    node.form = formBuilder.get(nodeData.form);
                    return node;
                }

                default: {
                    node = new Node(nodeData.id, nodeData.type, nodeData.title);
                    node = this.checkUnrequiredParams(node, nodeData);
                    return node;
                }
            }
        }

        return this.get("0");
    }

    checkUnrequiredParams(node, nodeData) {
        if (nodeData.titleBody) {
            node.titleBody = nodeData.titleBody
        }
        if (nodeData.body) {
            node.body = nodeData.body
        }
        if (nodeData.meta) {
            node.meta = nodeData.meta;
        }
        return node;
    }

    clearMetaDescr(texte) {
        //Coupe a 117 characters et met ...
        if (texte.length > 120) {
            texte = texte.slice(0, 117);
            texte += "...";
        }
        //Retire les balises
        if (texte.includes("<")) {
            while (texte.includes("<")) {
                let openPosition = texte.indexof("<");
                let closePosition = texte.indexof(">");
                let textePart1 = texte.slice(0, openPosition + 1);
                let textePart2 = texte.slice(closePosition + 1);
                texte = textePart1 + textePart2;
            }
        }
        return texte;
    }
}

export default NodeBuilder;